import { iStatus, UserStatus } from '../types/status'
import { iUser } from '../types/user'

export const getStatus = (
  status: iStatus,
  user: iUser
) => {
  if (status) {
    return status.status['@type'] === UserStatus.online
  }

  if (user) {
    return user.status['@type'] === UserStatus.online
  }

  return false
}
